import type { RouteObject } from "react-router";

/** The salon's articles (TDD-SA FR-SA-192): public, and loaded on demand, not with the home page. */
export const articlesRoutes: RouteObject[] = [
  { path: "articles", lazy: async () => ({ Component: (await import("./pages/ArticlesPage")).ArticlesPage }) },
  { path: "articles/:id", lazy: async () => ({ Component: (await import("./pages/ArticlePage")).ArticlePage }) },
];
